export default __webpack_public_path__ + "static/media/img1.4eb5e8d9.png";